export default function ({ backgroundColor, rootHeight: height, rootWidth: width, rootZIndex: zIndex }) {
  return {
    backgroundColor,
    height,
    width,
    zIndex
  };
}
